module.exports = __webpack_public_path__ + "img/eco-img-en.857a4ef5.png";